import { Component, OnInit, Input } from '@angular/core';
import { PaymentAccountConfigBaseComponent } from '../payment-account-config-base/payment-account-config-base.component';
import { VPSLineItemDetail, VpsPaymentProcessorAccountConfiguration } from '../../../models/payment-providers/vps/vps-payment-processor-account-configuration';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'wm-payment-account-config-vps',
    templateUrl: './payment-account-config-vps.component.html',
    styleUrls: ['./payment-account-config-vps.component.css'],
    standalone: false
})
export class PaymentAccountConfigVpsComponent
  extends PaymentAccountConfigBaseComponent
  implements OnInit {
  @Input() config: VpsPaymentProcessorAccountConfiguration;

  VPSLineItemDetail = VPSLineItemDetail;

  constructor(fb: UntypedFormBuilder) {
    super(fb);
    // this.showUsername = false;
  }

  ngOnInit() {
    if (!this.config || !this.config.lineItemDetailField) {
      this.config.lineItemDetailField = VPSLineItemDetail.Recipient
    }

    this.addValidation('partnerId', Validators.required, this.config.partnerId);
    this.addValidation('lineItemDetailField', Validators.required, this.config.lineItemDetailField);
  }
}
